export default __webpack_public_path__ + "static/media/KZ.T.13.2481 black.cc952fbf.svg";